import Button from '@/components/core/Button/Button';
import Heading from '@/components/core/Heading/Heading';
import AddPost from '@/components/features/posts/AddPost/AddPost';
import Filter from '@/components/features/posts/Filter/Filter';
import PostItem from '@/components/features/posts/PostItem/PostItem';
import PostsContainer from '@/components/features/posts/PostsContainer/PostsContainer';
import { ICollectionResource } from '@/interfaces/ICollectionResource';

import { slugify } from '@/utils/slug';
import { withTranslation, WithTranslation } from 'next-i18next';
import { NextRouter, withRouter } from 'next/router';
import { Component } from 'react';

import styles from './CollectionPosts.module.scss';

interface WithRouterProps {
	router: NextRouter;
}

interface ICollectionPostsProps extends WithTranslation, WithRouterProps {
	collections: Array<ICollectionResource>;
	meta: any;
	onLoadMore: () => void;
	hasMore: boolean;
	loading: boolean;
}

const getSlug = (item: ICollectionResource) => {
	return item.slug || slugify(item);
};

const getPostItems = (data: Array<ICollectionResource>) => {
	return data.map((item) => {
		const to = '/explore/' + getSlug(item);

		return <PostItem data={item} key={item.id} withActions to={to} />;
	});
};

class CollectionPosts extends Component<ICollectionPostsProps> {
	render() {
		const { collections, t, onLoadMore, meta, hasMore, loading } = this.props;

		const pinItemText = 'contribute-objects';

		const pin = <AddPost key={'pin'} text={pinItemText} icon="/assets/icons/donate.svg" to="contribute" />;

		return (
			<div className={styles.posts}>
				<Heading text={`${t('collection')} (${meta.totalCount})`}>
					{/* There are filters on the meta object, but on production site are not shown. Maybe is some bussines logic */}
					{/* collection={meta.filters} */}
					<Filter collection={[]} />
				</Heading>
				<div className={styles.postsContent}>
					<PostsContainer key={collections.length}>{[pin, ...getPostItems(collections)]}</PostsContainer>
				</div>
				{hasMore ? (
					<div className={styles.postsAction}>
						<Button onClick={onLoadMore} color={Button.color.PRIMARY} size={Button.size.BIG} loading={loading}>
							{t('load-more')}
						</Button>
					</div>
				) : null}
				{hasMore ? <p className={styles.panelSeparator}>{t('or')}</p> : null}
			</div>
		);
	}
}

export default withTranslation()(withRouter(CollectionPosts));
